import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';

import { MenuItems } from './Menu';
import logo from '../_img/logo.svg';

const pageTitle = (pathname) => {
    const parts = (pathname || '').split('/');
    const item = MenuItems.find((entry) => {
        const main = entry.to.split('/');
        return parts[1] === main[1];
    });
    return item ? item.title : 'ProfContact';
};

const HeaderClock = () => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const tick = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(tick);
    }, []);

    const pad = (value) => String(value).padStart(2, '0');
    const time = `${pad(now.getHours())}:${pad(now.getMinutes())}`;
    const date = `${pad(now.getDate())}.${pad(now.getMonth() + 1)}`;

    return (
        <time className="pc-mbar__time" dateTime={now.toISOString()}>
            <span>{date}</span>
            <b>{time}</b>
        </time>
    );
};

const MenuAppBar = ({ isLoading, onOpen, open, location }) => {
    if (open) return null;

    return (
        <header className="pc-mbar">
            <button
                type="button"
                className="pc-mbar__menu"
                onClick={onOpen}
                aria-label="Открыть меню"
            >
                <MenuIcon />
            </button>
            <Link to="/" className="pc-mbar__brand" aria-label="На главную">
                <img src={logo} alt="" />
            </Link>
            <div className="pc-mbar__title">{pageTitle(location.pathname)}</div>
            <HeaderClock />
            {isLoading ? <span className="pc-mbar__load" /> : null}
        </header>
    );
};

const mapState = (state) => {
    const { fetch } = state;
    return {
        isLoading: fetch ? fetch.loading > 0 : false,
    };
};

export default compose(
    connect(mapState),
    withRouter,
)(MenuAppBar);
